import React from "react";
import { searchFeedbackCategorys } from "../../../graphql/queries";
import * as ModelTypes from "../../../graphql/Constants/ModelTypes";
import DataGrid from "../../Common/DataGrid";
import * as DataTypes from "../../../constants/Data/DataTypes";
import * as QueryTypes from "../../../graphql/Constants/QueryTypes";

const FeedbackCategories = (props) => {
    return (
        <DataGrid
          {...props}
          header="Feedback Categories"
          gridObjectDataModel={[
            { name: "name", headerText: "Name", type: DataTypes.String },
            { name: "order", headerText: "Order", type: DataTypes.Number },
            {
              name: "createdAt",
              headerText: "Created At",
              type: DataTypes.DateTime,
            },
          ]}
          modelType={ModelTypes.FeedbackCategory}
          queryFunction={searchFeedbackCategorys}
          queryFunctionType={QueryTypes.Search}
          queryName={"searchFeedbackCategorys"}
          hasCreate={true}
          hasDetails={true}
          hasEdit={true}
          hasDelete={true}
          baseRoute={"feedbackCategories"}
        />
      );
};

export default FeedbackCategories;
